/** Browser-safe ordering and merge helpers; message bodies are append-only in storage. */
export type MessagePosition = { id: string; createdAt: number };
export function messageCursor(message: MessagePosition): string {
  const bytes = new TextEncoder().encode(JSON.stringify({ createdAt: message.createdAt, id: message.id }));
  return btoa(String.fromCharCode(...bytes)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
export function mergeMessagePage<T extends MessagePosition>(current: T[], incoming: T[], dropLocal = false): T[] {
  const byId = new Map(current.filter(message => !dropLocal || !message.id.startsWith("local-")).map(message => [message.id, message]));
  for (const message of incoming) byId.set(message.id, message);
  return [...byId.values()].sort((a, b) => a.createdAt - b.createdAt || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
}
